import { render, staticRenderFns } from "./LPPunchPlates_v1_27_0.vue?vue&type=template&id=cc999aac&scoped=true"
import script from "./LPPunchPlates_v1_27_0.vue?vue&type=script&lang=js"
export * from "./LPPunchPlates_v1_27_0.vue?vue&type=script&lang=js"
import style0 from "./LPPunchPlates_v1_27_0.vue?vue&type=style&index=0&id=cc999aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc999aac",
  null
  
)

export default component.exports